<template>
  <div>
    <div class="blocks">
      <div class="pt-3 l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h1 class="pr-3 w-full">Ratings & Reviews</h1>
          <div class="input-group search">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-11 filters-field">
          <span>Filters:</span>
          <span v-if="filtersLoaded">
            <span v-if="filters.companyStatus && companyStatuses && companyStatuses.length > 0" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('companyStatus')" />
              Status: {{ companyStatuses.find(el => el.id === filters.companyStatus).name }}</span>
          </span>
          <button class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
      </div>
    </div>
    <template v-if="!companies">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="blocks">
        <RatingsBlock
          v-for="(company, index) in companies"
          :key="index"
          :company.sync="company"
        />
      </div>

      <div class="row blocks">
        <div class="col-sm-6 mb-1 text-black-50 pl-0"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
      </div>
    </template>

    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Company Status</label>
                      <simple-select v-model="filters.companyStatus"
                                     :options="companyStatuses"
                                     placeholder="Select Status"
                                     @input="search"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="filters.companyStatus"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Pagination from '../../Pagination';
import RatingsBlock from './RatingsBlock';

export default {
  components: {
    RatingsBlock,
    Pagination,
  },
  data: () => ({
    filters: {
      companyStatus: '',
      sortKey: '',
      sortOrders: '',
    },
    page: 1,
    q: '',
    showFilters: false,
  }),
  computed: {
    ...mapState({
      companies: state => state.companies.paginatedCompanies.data,
      meta: state => state.companies.paginatedCompanies.meta,
      companyStatuses: state => state.values.companyStatuses,
      filtersSaved: state => state.filters.filtersSaved,
      filtersLoaded: state => state.guard.filtersLoaded,
    }),
    ...mapGetters(['getCompaniesFiltered', 'getFiltersSaved']),
  },
  created() {
    this.getFiltersSaved();
  },
  mounted() {
    if (this.filtersSaved && this.filtersSaved.previousPage === 'CompanyRatings') {
      this.filters = { ...this.filtersSaved };
      this.page = this.filtersSaved.page;
    } else if (Object.keys(this.$route.query).length !== 0) {
      this.setFilters(this.$route.query);
    }
    this.filter();
  },
  methods: {
    ...mapActions(['getPaginatedCompanies']),
    ...mapMutations(['setPaginatedCompanies', 'setFiltersSaved']),
    setFilters(query) {
      this.filters = Object.assign(
        {
          companyStatus: query.status_id ? parseInt(query.status_id, 10) : '',
          sortKey: query.sort,
          sortOrders: query.order,
        },
        {},
      );
      this.page = query.page;
      this.q = query.q.toString();
    },
    view(event, id) {
      this.setFiltersSaved({ ...this.filters, previousPage: 'CompanyRatings', page: this.page });
      if (event.button === 1) {
        window.open(this.$router.resolve(`/reports/ratings/${id}`).href, '_blank');
      } else {
        this.$router.push(`/reports/ratings/${id}`);
      }
    },
    changePage(pageNum) {
      this.setPaginatedCompanies({});
      this.page = pageNum;
      this.filter();
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      const query =
        `page=${this.page}&status_id=${this.filters.companyStatus}` +
        `&q=${encodeURIComponent(this.q)}` +
        `&sort=${this.filters.sortKey}&order=${this.filters.sortOrders}`;
      if (this.$_checkProperties(this.filters)) {
        this.$router.push(`/reports/ratings?${query}`);
      } else {
        this.$router.push(`/reports/ratings`);
      }
      this.getCompaniesFiltered(query);
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          companyStatus: '',
          sortKey: '',
          sortOrders: '',
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    sortBy(key) {
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters, 'sortOrders', this.filters.sortOrders === 'desc' ? 'asc' : 'desc');
      this.filter();
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      } else {
        this.filters[model] = '';
      }
      this.search();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'CompaniesEdit') {
      this.setFiltersSaved({});
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
.w-full {
  width: 470px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ratings/Ratings.vue